module.exports = __webpack_public_path__ + "static/media/DESTINATION-WEDDINGS-IN-PORTUGAL-BREAKFAST-2.61cb4e4f.jpg";